import { useContext, useEffect } from 'react';
import { PaymentInfoContext } from '../../App';

function MetadataUpdater() {
  const paymentInfo = useContext(PaymentInfoContext);

  useEffect(() => {
    if (paymentInfo) {
      const previewImage = paymentInfo?.companyStyle?.backgroundPicture;
      if (previewImage) {
        const ogImage = document.getElementById('og-image');
        const twitterImage = document.getElementById('twitter-image');
        
        if (ogImage) ogImage.setAttribute('content', previewImage);
        if (twitterImage) twitterImage.setAttribute('content', previewImage);
      }

      const logoImage = paymentInfo?.companyLogo;
      if (logoImage) {
        const favicon = document.getElementById('favicon');
        const shortcutIcon = document.getElementById('shortcut-icon');
        
        if (favicon) favicon.setAttribute('href', logoImage);
        if (shortcutIcon) shortcutIcon.setAttribute('href', logoImage);
      }
    }
  }, [paymentInfo]);

  return null;
}

export default MetadataUpdater;